import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { routes } from '@sketch/modules-common'

// Components
import { Grid, Text } from '@sketch/components'
import { convertSize } from '@sketch/discover'

// Local Components
import CommunityWrapper from '../../components/CommunityWrapper'
import EditorialItem from '../../components/EditorialItem'

// Styles
import { Description, Header, Title, Search } from './CommunityHubPage.styles'

// Types
import {
  CommunitySectionFragment,
  useGetCommunityPageItemsQuery,
} from '@sketch/gql-types'

import CommunityHubPagePlaceholder from './CommunityHubPagePlaceholder'

const Section = ({ size, items }: CommunitySectionFragment) => (
  <Grid.Column {...convertSize(size)}>
    {items.map(item => (
      <EditorialItem key={item.id} context="COMMUNITY" item={item} />
    ))}
  </Grid.Column>
)

const CommunityHubPage = () => {
  const [search, setSearch] = useState('')
  const { push } = useHistory()

  const { data, error, loading } = useGetCommunityPageItemsQuery()

  const sections = data?.community.sections || []

  let content = null

  if (loading) {
    content = <CommunityHubPagePlaceholder />
  } else if (error || !data) {
    content = null
  } else {
    content = (
      <Grid>
        {sections.map(section => (
          <Section key={section.id} {...section} />
        ))}
      </Grid>
    )
  }

  return (
    <CommunityWrapper>
      <Header>
        <Title>
          <Text textStyle="header.primary.I">Community Canvas</Text>
          <Description>
            Explore our curated collection of freely-available resources, made
            with love by Sketch and the community.
          </Description>
        </Title>

        <Search
          onChange={setSearch}
          onSubmit={() => {
            push(routes.COMMUNITY_CANVAS.create({ query: { search } }))
          }}
          value={search}
          name="search"
          placeholder="Search resources..."
        />
      </Header>

      <>{content}</>
    </CommunityWrapper>
  )
}

export default CommunityHubPage
